<div
    [ngClass]="{
        'card-container': !isStatic,
        'static-card-container': isStatic,
    }"
  >
  @for (page of pages; track page) {
    <app-card
      [avatar]="page.headerImageSourceUrl"
      [title]="page.title"
      subtitle="Atom"
      [guidanceStatus]="page.guidanceStatus"
      [scopePlatform]="page.scopePlatform"
      [description]="page.summary"
      [link]="page.slug"
      [isStatic]="isStatic"
      [content]="page.content"
      >
    </app-card>
  }
</div>
